import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { VivaConfigRequest } from '@/api/endpoints/viva-config'
import { vivaConfigApi } from '@/api/endpoints/viva-config'

/** 404 means "no ISV config" (merchant scheme), not an error — mapped to null. */
export function useRestaurantVivaConfig(restaurantId: number) {
  return useQuery({
    queryKey: ['restaurantVivaConfig', restaurantId],
    queryFn: async () => {
      try {
        return await vivaConfigApi.get(restaurantId)
      } catch (e: any) {
        if (e?.status === 404) return null
        throw e
      }
    },
    staleTime: 0,
  })
}

export function useSaveRestaurantVivaConfig(restaurantId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: VivaConfigRequest) =>
      vivaConfigApi.save(restaurantId, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['restaurantVivaConfig', restaurantId] })
    },
  })
}

export function useRemoveRestaurantVivaConfig(restaurantId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => vivaConfigApi.remove(restaurantId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['restaurantVivaConfig', restaurantId] })
    },
  })
}
